import React from 'react'
import { Helmet } from 'react-helmet'

import './BreakHTMLFooter.scss'
const BreakHTMLFooter = props => {
  const { content } = props

  return content ? (
      <div className={`break-html-footer`}>
        {/* Creative has been using styles that depend on this terrible use of Helmet, e.g.:
          body[break-html-footer=visible] .landing-step-new .content-wrapper {
         */}
        <Helmet
          bodyAttributes={{
            'break-html-footer': `${content ? `visible` : ``}`,
          }}
        />
          <div
            className={`break-html-content`}
            dangerouslySetInnerHTML={{ __html: content }}
          />
      </div>
  )
  :
  null
}
export default BreakHTMLFooter
